import { SolIconSize } from './sol-icon-style';

/** The icon sizes a spinner stands in for: a log step, a button or field, a refreshing widget, or the box it is given. */
export type SolSpinnerSize = Extract<SolIconSize, '12' | '16' | '32' | 'auto'>;

/** When a countdown starts and when it runs out. */
export interface SolSpinnerCountdown {
  readonly startsAt: Date;
  readonly endsAt: Date;
}

export class SolSpinner {
  private constructor(public readonly countdown: SolSpinnerCountdown | undefined) {}

  public static of(): SolSpinner {
    return new SolSpinner(undefined);
  }

  public static ofCountdown(startsAt: Date, endsAt: Date): SolSpinner {
    return new SolSpinner({ startsAt, endsAt });
  }
}
